import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { _setupStore } from './shared/state/setupStore';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <>
    <Provider store={_setupStore}>
      <App />
    </Provider>
  </>,
);
